import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import moment from 'moment-timezone';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { imagePath } from '../../../utilities/UrlPaths';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

const postSale = (num, type = 'Live') => {
  const postObject = {
    0: 'Not Available on Site',
    1: 'Available on Site / View Only',
    2: `Available on Site / ${type}`,
  };
  return postObject[num];
};

const SessionDetails = ({
  buyPremiums,
  coverPhoto,
  isPublished,
  linkToStep,
  postSaleChannels,
  sessionDetails,
  shippingLocations,
  isShippingEnabled,
  shareCatalogUrlMap,
  toggleCoverPhotoModal,
  twoHrsPassed,
}) => {
  const {
    audioVideo,
    categories,
    city,
    consignContact,
    country,
    currency: {
      name: currencyName,
      code: currencyCode,
    },
    creator,
    description,
    eventDateUTCString,
    expertContact,
    isTimed,
    postCode,
    saleAdmin,
    street1,
    street2,
    state,
    title,
    TZ_zoneName: timeZoneName,
    vat,
    viewNotes,
  } = sessionDetails;

  const linkedFrom = 'step6';
  const sessionDateTime = moment.utc(eventDateUTCString).tz(timeZoneName).format('MMMM Do YYYY, h:mm A z');

  /**
   * (bnikom) filter only channels (AZ + INV) that can be shared + aren't view-only
   * (aka channel.state can only be 2)
   */
  const shareChannels = postSaleChannels.filter(channel => (
    channel.states.length === 1 && channel.states[0] === 2)
    && (channel.channelID === 4 || channel.channelID === 1));

  const renderShareChannels = (inputString, key = null) => (
    <p className="mb-0" key={key}>
      <a rel="noopener noreferrer" target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareCatalogUrlMap[key])}`} className="mb-0">
        <FontAwesomeIcon icon={['fab', 'facebook']} />
        &nbsp;{inputString}
      </a>
    </p>
  );

  return (
    <Fragment>
      <Row>
        {/* 1st Column */}
        <Col xs={4}>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">
                Session Title
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(1),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              <p className="mb-0">{title}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Session Date & Time
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(1),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              <p className="mb-0">{sessionDateTime}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Session Location
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(1),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              {street1 && <p className="mb-0">{street1}</p>}
              {street2 && <p className="mb-0">{street2}</p>}
              <p className="mb-0">{city ? `${city}, ` : ''}{state ? `${state} ` : ''}{postCode || ''}</p>
              {country && <p className="mb-0">{country}</p>}
            </Col>
          </Row>
          {isShippingEnabled && (
            <Row className="mb-3 shipping-terms-container">
            <Col>
              <Stack direction="row" spacing={1}>
                <Chip label="NEW" color="primary" sx={{height: '22px'}}/>
                <strong id="shippingTermsText">
                  Shipping Fulfillment Location:
                </strong>
                </Stack>
                {shippingLocations && <p className="mb-0">{shippingLocations.address.addressLine1}</p>}
                {shippingLocations && <p className="mb-0">{shippingLocations.address.city}</p>}
                {shippingLocations && <p className="mb-0">{shippingLocations.address.state} {shippingLocations.address.postalCode}</p>}
                <p>
                  Shipping Contact:
                </p>
                {shippingLocations && <p className="mb-0">{shippingLocations.contacts[0].fullName}</p>}
                {shippingLocations && <p className="mb-0">{shippingLocations.contacts[0].email}</p>}
                {shippingLocations && <p className="mb-0">{shippingLocations.contacts[0].phoneNumber}</p>}
            </Col>
          </Row>
          )}

          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Contacts
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(2),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              <p className="mb-0">Consignment Contact: <span className="color-blue">{consignContact || ''}</span></p>
              <p className="mb-0">Sale Administrator: <span className="color-blue">{saleAdmin || ''}</span></p>
              <p className="mb-0">Expert Contact: <span className="color-blue">{expertContact || ''}</span></p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Post Sale To
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(2),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              {postSaleChannels.map(channel => (
                <p key={channel.channelID} className="mb-0">
                  {channel.channelName}: {postSale(channel.states[0], (isTimed ? 'Timed' : 'Live'))}
                </p>
              ))}
            </Col>
          </Row>
          {isPublished && shareChannels.length > 0
            && (
            <Row className="mb-3">
              <Col>
                {shareChannels.length > 1
                  && shareChannels.map(channel => (
                    renderShareChannels(`Share ${channel.channelName} Catalog on Facebook`, channel.channelID)
                  ))}
                {shareChannels.length <= 1
                  && renderShareChannels('Share on Facebook', shareChannels[0].channelID)}
              </Col>
            </Row>
            )}
        </Col>
        {/* 2nd Column */}
        <Col xs={4}>
          {isTimed === 0
            && (
            <Row className="mb-3">
              <Col>
                <p className="font-weight-bold mb-0">A/V Broadcast
                  <Link
                    to={{
                      pathname: linkToStep(2),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                </p>
                <p className="mb-0">{(audioVideo === 0) ? 'No' : 'Yes'}</p>
              </Col>
            </Row>
            )}
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Buyer&apos;s Premium</p>
              {buyPremiums.map(premium => (
                <p key={premium.stepPct} className="mb-0">
                  {premium.from}-{premium.to} {currencyCode} = {premium.stepPct}%
                </p>
              ))}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Currency</p>
              <p className="mb-0">{currencyName} ({currencyCode})</p>
              <p className="mb-0">+VAT: {vat === 0 ? 'No' : vat}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Session Categories for Email Alerts
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(2),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              {Object.keys(categories).map(category => (
                <Fragment key={category}>
                  <p className="mb-0">{category}</p>
                  <p className="mb-0">{categories[category].map(arrayCategory => (
                    <Fragment key={arrayCategory}>
                      <span>&emsp;{arrayCategory}</span>
                      <br />
                    </Fragment>
                  ))}
                  </p>
                </Fragment>
              ))}
            </Col>
          </Row>
        </Col>
        {/* 3rd Column */}
        <Col xs={4}>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Session Cover Image</p>
              <div className="img-container d-flex align-items-center">
                <button className="edit-button cover-photo-edit-button" onClick={toggleCoverPhotoModal} type="button">
                  <FontAwesomeIcon icon="edit" className="color-blue" size="lg" />
                </button>
                <img
                  className="mh-100"
                  src={coverPhoto || `${imagePath}/images/NoImage.png`}
                  alt={title || 'No image'}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4 mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Session Description
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(2),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              <p className="text-clamp-2 mb-0">{description || 'none'}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <p className="font-weight-bold mb-0">Viewing Notes
                {!twoHrsPassed
                  && (
                  <Link
                    to={{
                      pathname: linkToStep(2),
                      state: { linkedFrom }
                    }}
                    aria-label="Edit"
                    className="ml-1"
                  >
                    <FontAwesomeIcon icon="edit" className="btn-link" />
                  </Link>
                  )}
              </p>
              <p className="text-clamp-2 mb-0">{viewNotes || 'none'}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="font-weight-bold mb-0">Created By</p>
              <p className="mb-0">{creator}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SessionDetails;
